import React, { useEffect, useRef } from "react";
import interact from "interactjs";
import useCurrentValue from "../../hooks/useCurrentValue";
import { moveMultipleObjects } from "../reducers/slices/phases.js";
import { useDispatch } from "react-redux";
import { IconButton } from "@mui/material";
import Iconify from "../../components/Iconify";

const transformToScreen = (x, y) => {
  let svg = document.querySelector("#editor_court");
  if (!svg) return [];
  let pt = svg.createSVGPoint();
  pt.x = x;
  pt.y = y;
  pt = pt.matrixTransform(svg.getScreenCTM());
  return [pt.x, pt.y];
};

export default function SelectionRectangle({
  selectionRect,
  pixelPerFoot,
  affectedObjects,
  court,
  manualPositioningContextMenu = () => {},
}) {
  const dispatch = useDispatch();
  const rectRef = useRef();
  const courtRef = useCurrentValue(court);

  const pixelPerFootRef = useCurrentValue(pixelPerFoot);

  const affectedObjectsRef = useCurrentValue(affectedObjects);

  function updatePosition(x) {
    let target = x.target;

    target.style.transform = "";

    affectedObjectsRef.current.forEach((obj) => {
      document.getElementById("editor_" + obj.id).style.transform = "";
      document.getElementById("editor_" + obj.id).style.transformOrigin = "";
    });

    let deltaX = parseFloat(target.getAttribute("delta-x")) || 0;
    let deltaY = parseFloat(target.getAttribute("delta-y")) || 0;

    dispatch(
      moveMultipleObjects({
        objects: affectedObjectsRef.current,
        x: courtRef.current.full ? -deltaY : deltaX,
        y: courtRef.current.full ? deltaX : deltaY,
        court: courtRef.current,
      })
    );

    target.setAttribute("delta-x", 0);
    target.setAttribute("delta-y", 0);
  }

  function dragMoveListener(event) {
    var target = event.target;
    var x =
      (parseFloat(target.getAttribute("delta-x")) || 0) +
      event.dx / pixelPerFootRef.current;
    var y =
      (parseFloat(target.getAttribute("delta-y")) || 0) +
      event.dy / pixelPerFootRef.current;
    target.style.transform = "translate(" + x + "px, " + y + "px)";
    target.setAttribute("delta-x", x);
    target.setAttribute("delta-y", y);

    affectedObjectsRef.current.forEach((obj) => {
      let element = document.getElementById("editor_" + obj.id);
      element.style.transform = `translate(${x}px,${y}px)  ${
        element.dataset.rotate ?? ""
      } `;
      element.style.transformOrigin = `${
        element.dataset.transformOrigin ?? ""
      }`;
    });
  }

  useEffect(() => {
    interact(rectRef.current).draggable({
      ignoreFrom: "textarea",
      modifiers: [
        interact.modifiers.restrict({
          restriction: "#editor_wrapper",
        }),
      ],
      onend: updatePosition,
      onmove: dragMoveListener,
    });
    let cleanUpRef = rectRef.current;
    return () => interact(cleanUpRef).unset();
  }, []);

  return (
    <g ref={rectRef}>
      <rect
        style={{ cursor: "grab" }}
        x={selectionRect.x}
        y={selectionRect.y}
        width={selectionRect.width}
        height={selectionRect.height}
        fill="rgba(255,255,255,0.2)"
        stroke="rgb(10, 132, 255)"
        strokeWidth={2 / pixelPerFoot}
      />

      <svg
        x={selectionRect.x + selectionRect.width + 4 / pixelPerFoot}
        y={selectionRect.y + 2 / pixelPerFoot}
        width={35 / pixelPerFoot}
        height={35 / pixelPerFoot}
        viewBox="0 0 28 28"
      >
        <foreignObject x={0} y={0} width={35} height={35}>
          <IconButton
            onClick={() => {
              let transformedCoords = transformToScreen(
                selectionRect.x + selectionRect.width - 140 / pixelPerFoot,
                selectionRect.y + 40 / pixelPerFoot
              );

              manualPositioningContextMenu(
                Math.max(0, transformedCoords[0]),
                transformedCoords[1]
              );
            }}
            size="small"
            sx={{
              position: "fixed",
              borderRadius: "5px",
              background: "#f5f5f5",
              ":hover": { background: "#fff" },
            }}
          >
            <Iconify color="black" icon={"eva:chevron-down-fill"} />
          </IconButton>
        </foreignObject>
      </svg>
    </g>
  );
}
